module.exports = __webpack_public_path__ + "img/big.f5aa69a1.jpg";